<template>
  <v-card flat>
    <v-card-text>
      <p class="subheading font-weight-medium text-uppercase text-xs-center my-5">
        Termos de Uso da Plataforma Zipper
      </p>
      <p>
        Este instrumento contém os
        <span class="font-weight-bold text-uppercase">termos gerais e condições de uso</span> da
        Plataforma ZIPPER (a “Plataforma”), do Web Site e demais serviços oferecidos por qualquer
        meio, devendo o USUÁRIO respeitar todas as obrigações de disposições previstas neste
        instrumento.
      </p>
      <p>A <span class="font-weight-bold text-uppercase">Plataforma Zipper</span> é um sistema computacional que gerencia dados e documentos a fim de auxiliar o processo de vendas no varejo com criação de campanhas customizadas, agenda com contatos e catálogos digitais.</p>
      <p>
        A Plataforma é desenvolvida e mantida pela
        <span
          class="font-weight-bold text-uppercase"
        >Zipper Soluções Tecnológicas LTDA., (“Nós”; “ZIPPER”),</span>
        uma pessoa jurídica de direito privado, inscrita no CNPJ sob o nº 32.672.392/0001-21, que lhe
        disponibiliza o uso da mesma para a inserção de dados próprios e de terceiros, respeitando-se
        as disposições legais.
      </p>
      <p class="underline font-weight-medium">
        Se Você não concorda com estas Condições Gerais de Uso, não use os Serviços da Plataforma da
        ZIPPER, de seu Web Site e demais serviços por outros canais. O uso de qualquer serviço da
        ZIPPER, por qualquer meio implica na integral aceitação dos termos aqui previstos.
      </p>
      <p class="underline font-weight-medium">
        O Web Site e a Plataforma são de uso público em geral e não coleta dados pessoais de qualquer
        pessoa sob a idade de 18 anos sem consentimento dos pais ou responsáveis. Ao aceitar o
        presente Termo, você declara sob as penas da lei, ter 18 anos de idade ou mais.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        1. Acesso à plataforma, ao website e aos serviços.
      </p>
      <p>
        1.1. A fim de acessar a Plataforma, o Web Site e usar os Serviços, Você deve manter e operar
        o software e hardware e conexão à internet necessários para tal. Você é exclusivamente
        responsável por adquirir, instalar e manter todo o software e hardware necessários para
        acessar o Web Site e usar os Serviços e, Nós não nos responsabilizamos por qualquer
        dificuldade técnica, que Você enfrente, decorrentes do uso desse software, hardware, e
        conexão à internet.
      </p>
      <p>
        1.2. A ZIPPER se reserva ao direito de alterar, suspender, terminar ou descontinuar qualquer
        aspecto da Plataforma, a qualquer tempo, incluindo disponibilidade de qualquer Serviço,
        informações, características ou funcionalidades acessíveis por meio da Plataforma. Nós
        também podemos impor limitações a certas características, funcionalidades ou serviços ou
        restringir Seu acesso a partes ou toda Plataforma sem prévia notificação e sem que isso
        implique em alguma responsabilidade Nossa por qualquer prejuízo que venha a sofrer.
      </p>
      <p>
        1.3. Quaisquer melhorias ou adições à Plataforma, ou aos Serviços prestados estarão sujeitos
        a este Termo de Uso, a não ser que Nós estabeleçamos expressamente de outra forma. Nós
        podemos introduzir novos conjuntos específicos de termos e condições para Serviços
        específicos, conforme apropriado, ou emendar termos e condições específicos existentes.
      </p>
      <p>
        1.4. Nós nos reservamos o direito de controlar, alterar a aparência, desenvolvimento e
        operações da Plataforma à Nosso exclusivo critério, bem como estabelecer e mudar os
        procedimentos para o Seu contato Conosco, sem notificação.
      </p>
      <p>
        1.5. A ZIPPER exige que Você se cadastre antes de escolher qualquer parte dos serviços não
        cobrados, e/ou solicitar que Você se cadastre antes de escolher qualquer parte do serviço
        seja ele gratuito ou mediante cobrança.
      </p>
      <p>
        1.6. Quando Você se cadastrar, independentemente de finalizar o procedimento, Você concorda
        em fornecer informações verdadeiras, corretas, atualizadas e completas (“Dados de Cadastro”)
        conforme solicitados no formato de cadastro disponibilizado a Você através da Plataforma.
      </p>
      <p>
        1.7. Nós podemos depender dos seus Dados de Cadastro para estabelecer Sua situação de
        negócio, para fornecer informação sobre os Nossos Serviços, ou alternativamente para
        identificar e/ou entrar em contato com Você. Se Seus Dados de Cadastro não são verdadeiros e
        corretos, ou são desatualizados e incompletos, Nós podemos notificar por e-mail que Você
        encerre o Serviço imediatamente ou suspenda Sua conta e todos os usos correntes ou futuros
        dos Serviços (ou qualquer parte deles).
      </p>
      <p>
        1.8. Você receberá login e senha de conta no momento em que completar o processo de
        Cadastro. Você é responsável por manter a confidencialidade da senha e conta e é
        completamente responsável por todas as atividades que ocorrerem com o uso de Sua senha e
        conta.
      </p>
      <p>
        1.9. Além disso, Você concorda em:
        <ul>
          <li>
            notificar imediatamente a ZIPPER de qualquer uso não autorizado da Sua senha e
            conta ou qualquer outra violação de segurança; e
          </li>
          <li>assegurar que Você saia da sua conta ao final de cada sessão.</li>
        </ul>
      </p>
      <p>
        1.10.  Nós  não  seremos  responsáveis  por  qualquer  perda  ou  dano decorrente da
        sua falha em obedecer ao que estabelece esta seção.
      </p>
      <p class="font-weight-bold">
        1.11.  Quando Você se cadastrar na Plataforma, Você concorda que seu número de telefone poderá ser disponibilizado aos seus clientes para contato via aplicativos de mensagens, como WhatsApp e semelhantes. O uso da Plataforma caracterizará a Sua concordância com o compartilhamento do seu número de telefone. Se, por algum motivo, Você não concordar com a disponibilização do seu número de telefone, interrompa imediatamente o uso da Plataforma.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        2. Política Aceitável de Uso
      </p>
      <p>
        2.1. Você concorda em <span class="font-weight-bold underline">não:</span>
      </p>
      <ul class="mb-3">
        <li>compartilhar o login e a senha da Plataforma com terceiros;</li>
        <li>divulgar informações, imagens ou qualquer espécie de dado que não seja verídico;</li>
        <li>usar  a  Plataforma  e  qualquer  Conteúdo  dela,  bem  como  dos Serviços, para qualquer fim ilícito;</li>
        <li>tornar  disponíveis  conscientemente,  através  da  Plataforma  ou fazer  o  upload  quaisquer  materiais  não  pertencentes  ou licenciados a Você;</li>
        <li>disponibilizar  através  do  Web  Site  e  da  Plataforma,  ou  fazer upload de arquivos ou outros que Você sabe conter vírus, bug, dados corrompidos ou outros itens prejudiciais;</li>
        <li>interferir  com  o  funcionamento  normal  do  Web  Site  e  da Plataforma;</li>
        <li>interferir  no  uso  e  acesso  de  outras  partes  ao  Web  Site  e  a Plataforma, em seus Conteúdos e Serviços; e</li>
        <li>publicar,  postar,  distribuir  ou  disseminar  materiais  ou informações difamatórias, transgressoras, obscenas, indecentes ou ilegais  através  dos  nossos  Serviços  do  Web  Site  e  a Plataforma.</li>
      </ul>

      <p class="caption font-weight-bold text-uppercase">
        2.2. A Zipper se reserva ao direito de suspender ou bloquear imediatamente seu
        acesso ao website ou a qualquer serviço, e remover quaisquer informações ou
        dados que considerarmos  uma violação de qualquer uma destas condições gerais
        de uso, sem aviso prévio e/ou disponibilizar dita informação quando solicitada
        por órgãos públicos ou por ordem judicial.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        3. Propriedade Intelectual.
      </p>
      <p>
        3.1.  A  ZIPPER  confere  a  Você,  apenas  os  direitos  expressamente previstos
        neste  Termo  e  nos  limites  do  Contrato  de  Prestação  de Serviço  celebrado
        e que originou  a  liberação  da  Plataforma  para  o Usuário (o “Contrato”),
        reservado à mesma todos os direitos, títulos e interesses relativos aos Serviços,
        incluindo todos os direitos de propriedade  intelectual  inerentes.  Não  será
        concedido  qualquer direito  à  Você  sobre  nenhuma  Propriedade  Intelectual
        de  Nossa propriedade.
      </p>
      <p>
        3.2.Você se compromete, sob as penas da lei, a <span class="font-weight-bold underline text-uppercase">não:</span>
      </p>
      <ul class="mb-3">
        <li>criar trabalhos derivados baseados nos serviços;</li>
        <li>copiar ou apresentar o conteúdo da Plataforma e do WebSite da ZIPPER dentro de outra Plataforma ou Web Site (emoldurar), nem reproduzir  qualquer  parte  ou  conteúdo  dos  serviços,  além  da cópia ou enquadramento em Suas próprias intranets, ou de outra forma para Seus próprios fins comerciais internos;</li>
        <li>realizar engenharia reversa dos serviços;</li>
        <li>revelar   a   terceiros   qualquer   Informação   Confidencial relacionada  à  Plataforma  e  aos  serviços,  dados  de  usuários, segredo  de  indústria  e  outros,  ou  usar  referidas  informações para qualquer propósito estranho ao Serviço.</li>
        <li>acessar  os  serviços  para  (a)  criar  um  produto  ou  serviço  que compita  com  ele,  ou  (b)  copiar  qualquer  recurso,  função  ou gráfico dos serviços.</li>
      </ul>

      <p class="font-weight-bold">
        3.3.  Você  se  compromete  ainda  a  não  inserir  na  Plataforma
        nenhuma informação,  imagem,  dados,  vídeos,  ou  qualquer  outra
        forma  de expressão que seja protegida por Direitos Autorais e para
        os quais Você não tenha licença de Uso.
      </p>
      <p class="font-weight-bold">
        3.4.  Ao  inserir  no  Web  Site  ou  Plataforma,  qualquer  informação,
        imagem,  dados,  vídeos,  ou  qualquer  outra  forma  de  expressão,
        Você estará automaticamente assumindo todas as responsabilidades sobre
        o uso das mesmas, inclusive por Nós.
      </p>
      <p>
        3.5.   Os  conteúdos  obtidos  pelo  uso  da  plataforma  da  ZIPPER  não
        poderão  ser  reproduzidos  ou  comercializados  pelo  usuário,  e  Você
        declara estar ciente de que todos os serviços do ZIPPER a que tiver acesso
        em conformidade com os termos de uso serão para uso único e exclusivo  do
        mesmo,  não  podendo  comercializá-los,  cedê-los  a terceiros  a  qualquer
        título  ou  explorá-los  economicamente  de qualquer forma, salvo se o Contrato
        de Prestação de Serviços dispor de  maneira  diversa,  sob  pena  cancelamento
        de  conta,  bloqueio  de acessos  futuros  e  remoção  de  seus  dados,  sem
        rejuízo  da responsabilidade  pelas  perdas  e  danos  causados  à  ZIPPER
        ou  a qualquer  empresa  a  ela  associada  na  prestação  dos  serviços
        em decorrência do não cumprimento do disposto neste Termo.
      </p>
      <p>
        3.6. Você declara que os dados inseridos na Plataforma foram obtidos e nela inseridos
        com o consenso do legítimo proprietário dos dados, e  que  este  também  concedeu
        à  ZIPPER  o  direito  de  utilizar  as informações inseridas na Plataforma,
        inclusive para transmiti-las ou exibi-las para terceiros.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        4. Inexistência de garantias.
      </p>
      <p>
        4.1.  Embora  Nós  tenhamos  envidado  nossos  melhores  esforços  para assegurar  que  o  Conteúdo
        do  Web  Site  e  da  Plataforma  sejam confiáveis, nenhuma garantia (explícita ou implícita) é feita
        quanto à  sua  exatidão,  integridade  ou  imparcialidade  e,  portanto,  Você deve, se necessário,
        obter uma verificação independente de quaisquer das informações aqui contidas.
      </p>
      <p>
        4.2.  Nós  (I)  não  assumimos  qualquer  responsabilidade,  de  qualquer natureza e qualquer título,
        acerca de qualquer Conteúdo constante do Web  Site,  da  Plataforma  ou  dos  Serviços  prestados  ou
        qualquer informação fornecida pelo ou através da Plataforma e do Web Site, e (II)  não  garantimos  que
        o  Web  Site,  a  Plataforma  ou  quaisquer Serviços ou Conteúdos dele serão ininterruptos ou livres de
        erros, que defeitos serão corrigidos ou que o Web Site, o servidor em que ele  é  disponibilizado  ou
        qualquer  sistema  conectado  a  ele,  está livre de vírus ou outros componentes nocivos.
      </p>
      <p>
        4.3.  Você  reconhece  que  Você  deve  usar  o  Web  Site,  a  Plataforma, seus  Conteúdos  e  os  Serviços
        por  sua  conta  e  risco,  e  que  o  Web Site,  a  Plataforma,  seus  Conteúdos  ou  os  Serviços  podem
        conter problemas  técnicos  ou  outras  limitações  pelas  quais  Nós  não assumimos    nenhuma    responsabilidade
        e    não    podemos    ser responsabilizados por quaisquer danos que possam surgir a partir de problemas técnicos,
        limitações, bugs ou vírus em conexão com o Seu acesso  a,  ou  uso  do  Web  Site  e  da  Plataforma,  seus  Conteúdos
        ou Serviços.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        5. responsabilidades da Zipper.
      </p>
      <p>
        5.1.  Exceto  no  caso  de  conduta  dolosa,  em  nenhum  momento  a  ZIPPER será  responsável  por  (a)
        perda  ou  dano  de  qualquer  natureza  que surja como resultado de qualquer Conteúdo publicado no Web
        Site ou na  Plataforma,  destas  Condições  Gerais  de  Uso,  dos  Serviços  ou qualquer  outra  informação,
        dados,  software  ou  serviço  fornecido através  do  Web  Site  ou  na  Plataforma;  ou  (b)  quaisquer
        perdas resultantes  de  ordens  ou  compras  de  bens  ou  serviços  de  terceiros feitos através ou baseados
        em informações ou no Conteúdo fornecido no Web Site. Nossa responsabilidade total e cumulativa com Você, em
        nenhuma circunstância será maior que R$ 1.000,00 (mil reais).
      </p>
      <p>
        5.2.  Em  nenhuma  hipótese  a  ZIPPER  será  responsável  por  quaisquer danos  indiretos,  de  qualquer
        natureza,  que  possam,  direta  ou indiretamente, ser atribuíveis ao uso, ou à incapacidade de uso do Web
        Site  ou  da  Plataforma,  dos  Serviços  ou  quaisquer  informações, dados,  software  ou  serviço  prestado
        através  do  Web  Site  e  da Plataforma, mesmo se advertido sobre a possibilidade de tais danos ou se tais danos
        eram previsíveis.
      </p>
      <p>
        5.3. Nós não seremos responsáveis perante Você por qualquer atraso ou  não  execução  dos  Serviços,  ou  falha
        em  acessar  a  Plataforma  ou qualquer  parte  do  Conteúdo  do  mesmo,  decorrente  de  qualquer  causa além  do
        nosso  razoável  controle  ou  de  prestadores  de  Nossos serviços.
      </p>
      <p>
        5.4.  Você  é  responsável  pelo  conteúdo  das  Suas  mensagens  ou quaisquer  outros  dados,  informações  ou
        materiais  distribuídos através do Web Site ou da Plataforma. Você é responsável por todas as  obrigações  perante
        terceiros  decorrentes  da  Sua  utilização  da Plataforma, incluindo contratuais, tributos e passivos regulatórios.
        Você  concorda  em  Nos  ressarcir  por  quaisquer  custos,  despesas  ou passivos  que  Nós  incorrermos,  e  quaisquer
        reivindicações  ou  ações judiciais que venham a ser propostas contra a ZIPPER em consequência do Seu uso dos Serviços,
        da Plataforma, bem como qualquer Conteúdo do mesmo.
      </p>
      <p>
        5.5.  A  ZIPPER  não  possui  quaisquer  relação  empregatícia  com  o Usuário  da  Plataforma  e,  em  nenhuma  hipótese,
        a  ZIPPER  será responsável  por  quaisquer  encargos  trabalhistas  que  decorram  da utilização, pelo Usuário, da Plataforma,
        do Web Site, e dos serviços relacionados, seja no horário de expediente do usuário ou fora dele.
      </p>
      <p>
        5.6 A ZIPPER não garante qualquer resultado econômico, financeiro ou lucros em decorrência do uso de Nossos serviços.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        6. responsabilidades do Usuário.
      </p>
      <p>
        6.1 Para usufruir da Plataforma, Você deverá observar a existência de   qualquer   impedimento   legal   ou   contratual
        a   que   esteja eventualmente   sujeito   inclusive,   mas   sem   se   limitar,   aos impedimentos  relativos  ao  tipo,
        espécie  e/ou  qualidade  de  conteúdo que vier a incluir no ZIPPER.
      </p>
      <p>
        6.2  Você  será  o  único  e  exclusivo  responsável  por  manter  as configurações  para  acesso  aos  serviços  contratados,
        sendo  proibido alterar endereços de máquinas, IP (“Internet Protocol”) de rede ou de correio eletrônico, na tentativa de
        responsabilizar terceiros ou ocultar a identidade ou autoria. Na hipótese de ocorrência dos casos aqui mencionados, o ZIPPER
        poderá disponibilizar a qualquer tempo às autoridades competentes toda e qualquer informação sobre o usuário, bem  como  cancelar
        sua  conta  automaticamente,  sem  prévio  aviso, respondendo o usuário civil e penalmente pelos atos praticados.
      </p>
      <p>
        6.3 Os códigos de usuário e as respectivas senhas privativas são de responsabilidade  exclusiva  do  usuário,  que  assume  toda
        e  qualquer responsabilidade  pelo  seu  uso  e  por  ações  realizadas  através  dos mesmos,   incluídos   os   encargos   econômicos
        daí   resultantes, especialmente no tocante a perda de dados, contaminação por vírus, invasão de redes, roubo de dados ou informações,
        envio de mensagens eletrônicas ofensivas ou inoportunas a outros usuários da Internet e demais condutas que venham a prejudicar outros
        usuários ou sistemas conectados à rede Internet, ou ainda por outras ações que estejam em desacordo com a legislação vigente.
      </p>
      <p>
        6.4 É de exclusiva responsabilidade do usuário prevenir-se contra a perda  de  dados,  uso  de  informações  indevidas  ou  quaisquer
        outros danos,  devendo  manter  inacessível  a  sua  senha,  excluindo-se, portanto, a responsabilidade do ZIPPER.
      </p>
      <p>
        6.5. O usuário declara e concorda expressamente que:
      </p>
      <ul class="listStyle mb-3">
        <li>Não irá divulgar propaganda ou anunciar produtos e serviços fins comerciais  sem  anuência  dos  destinatários,  bem  como  também  não divulgará  conteúdos  ilegais,  ideias  racistas  ou  referentes  a quaisquer outras práticas discriminatórias;</li>
        <li>Efetuará  em  favor  do  ZIPPER  os  pagamentos  devidos,  quando aplicáveis;</li>
        <li>Não  utilizará  os  serviços  do  ZIPPER  para  enviar/divulgar quaisquer tipos de marketing multinível ilegal, como um esquema de pirâmide, na rede;</li>
        <li>Não  utilizará  os  serviços  do  ZIPPER  para  enviar/divulgar quaisquer tipos de vírus ou conteúdos contendo quaisquer tipos de vírus  ou  que  possam  causar  danos  ao  seu  destinatário  ou  a terceiros;</li>
        <li>Não  irá  solicitar  informações  privadas  de  login  e  senha  de terceiros,  assim  como  não  irá  acessar  contas  que  pertençam  a terceiros;</li>
        <li>Não utilizará os serviços do ZIPPER para intimidar, assediar ou praticar bullying contra qualquer usuário;</li>
        <li>Não  utilizará  os  serviços  do  ZIPPER  para  obter  ou  tentar  obter acesso  não-autorizado  a  outros  sistemas  ou  redes  de  computadores conectados ao serviço;</li>
        <li>Será  o  único  responsável  pelo  conteúdo  que  vier  a  informar, transmitir ou retransmitir bem como pelo conteúdo e informações que vier a disponibilizar nos serviços ofertados pelo ZIPPER e/ou seus parceiros;</li>
        <li>Não irá tomar nenhuma ação que possa desabilitar, sobrecarregar, interromper  ou  impedir  os  serviços  ou  os  servidores  ou  redes conectadas ao serviço;</li>
        <li>Irá  cumprir  todos  os  procedimentos,  políticas,  normas  e regulamentos dos serviços do ZIPPER e de seus parceiros, divulgados nas páginas de cada serviço.</li>
        <li>Irá cumprir todas as exigências e obrigações legais que estiverem em vigor no Brasil ou no país de sua atuação, especialmente com a Lei Geral de Proteção de Dados e com o Marco Civil da Internet.</li>
        <li>
          Não utilizará a Plataforma fora do seu horário de trabalho.
        </li>
      </ul>

      <p class="font-weight-bold">
        6.6. A ZIPPER se reserva o direito de suspender o Seu acesso à sua conta da Plataforma em caso de descumprimento de qualquer cláusula deste
        Termo, bem como efetuar o cancelamento definitivo da mesma.
      </p>
      <p>
        6.7.  <span class="text-uppercase font-weight-bold">Reativação do Acesso:</span>  Caso  a  ZIPPER  não  cancele  o  acesso  aos seus
        serviços  por  motivos  de  violação  das  regras  e  normas  aqui vigentes por parte do usuário, o usuário poderá reativar os serviços a
        qualquer momento.
      </p>
      <p>
        6.7.1.  A  ZIPPER  não  se  responsabiliza  pela  exclusão  dos  dados cadastrais de usuários que cancelarem sua conta no ZIPPER.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        7. Condições Gerais.
      </p>
      <p>
        7.1.  Você  não  poderá  ceder,  sublicenciar,  subcontratar,  transferir ou dispor de quaisquer direitos e
        obrigações Seus no âmbito destas Condições Gerais de Uso sem o consentimento prévio da ZIPPER.
      </p>
      <p>
        7.2. Se em algum momento, qualquer disposição (ou parte de qualquer disposição)  deste  Termo  de  Uso  tornar-se
        ilegal,  inválida  ou inexequível em qualquer aspecto, sob a lei de qualquer jurisdição, isto não afetará ou
        prejudicará a legalidade, validade ou execução nessa ou em qualquer outra jurisdição de qualquer outra disposição
        (ou qualquer outra parte da mesma disposição) deste Termo.
      </p>
      <p>
        7.3. A ZIPPER se reserva ao direito de encerrar com o seu status de usuário  ou  com  a  sua  capacidade  de  uso
        total  ou  parcial  à Plataforma, do Web Site e dos serviços a qualquer momento, sem aviso prévio,  e  por  qualquer
        razão,  incluindo,  mas  não  se  limitando  as seguintes hipóteses:
      </p>
      <ul class="listStyle mb-3">
        <li>pela quebra de quaisquer das disposições do presente Termo ou do  Contrato,  por  quaisquer  das  partes,  de  forma  a  impedir  a continuidade da execução do objeto do presente Termo;</li>
        <li>se o usuário, de qualquer forma, comprometer a imagem pública do  ZIPPER  e/ou  de  qualquer  empresa  associada  ao  ZIPPER  na prestação dos serviços;</li>
        <li>se  o  usuário  utilizar  de  práticas  que  desrespeitem  a  lei,  a ordem pública, a moral, os bons costumes ou, ainda, a política de  segurança  e  privacidade  e  as  regras  e  normas  de  uso  do ZIPPER;</li>
        <li>pelo  não  pagamento,  de  qualquer  remuneração  devida  pelo Contratante à ZIPPER ou pelo Usuário à ZIPPER, relativa ao uso da Plataforma e dos serviços;</li>
        <li>Pelo término do Contrato de Prestação de Serviços celebrado com a ZIPPER do qual se originou a liberação da Plataforma para o Usuário.</li>
      </ul>
      <p>
        7.4.  A  ZIPPER  reserva-se  o  direito  de  suspender,  temporária  e indefinidamente,  bem  como  de  remover
        definitiva  e  completamente qualquer conteúdo ou informação postada pelo usuário.
      </p>
      <p>
        7.5. A ZIPPER reserva-se o direito de encerrar a conta ou o acesso total ou parcial a Plataforma e ao Web Site por motivo
        esclarecido nestes  Termos  de  Uso  sem  aviso  prévio,  e  entende  e  concorda  que poderá imediatamente desativar ou
        apagar a conta do usuário e todas as  informações  e  conteúdos  relativos  a  ela  e/ou  barrar  seu  acesso futuro  na
        Plataforma.  A  ZIPPER  não  será  responsabilizada  pelo usuário  ou  por  terceiros  pelo  encerramento  do  seu  uso
        de  todas  ou quaisquer partes da Plataforma.
      </p>
      <p>
        7.6.  Você  tem  o  direito  de  rescindir  a  aceitação  a  este  termo  de deixar  de  atender  as  condições  previstas
        neste  Termo  de  Uso, devendo,  no  entanto,  descontinuar  seu  acesso  ao  Web  Site,  à Plataforma e a todos os Serviços
        da ZIPPER, mediante notificação a esta.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        8. prazo.
      </p>
      <p>
        8.1. Estes Termos de Uso entram em vigor na data da efetivação do cadastro do Usuário na Plataforma, desde que dentro do lapso temporal do Contrato.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        9. Notificações.
      </p>
      <p>
        9.1. Todas as comunicações a serem realizadas em razão do Uso do Web Site  ou  da  Plataforma  da  ZIPPER  deve  ser  feita  através  do  email: suporte@sejazipper.com
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        10. Modificações deste termo de uso.
      </p>
      <p>
        10.1.  A  ZIPPER  se  reserva  o  direito,  a  seu  critério,  de  alterar, modificar, adicionar ou remover partes deste Termo de Uso a qualquer momento. Seu  uso  continuado  da  Plataforma  após  a  publicação  de alterações  a  estes  termos  significa  que  você  aceita  estas alterações.
      </p>
    </v-card-text>

    <v-card-text>
      <p class="font-weight-medium text-uppercase">
        11. Lei e foro.
      </p>
      <p>
        11.1. O presente Termo de Uso e todas as relações dele decorrentes são  submetidas  às  leis  da  República  Federativa  do  Brasil,  em especial o Marco Civil da Internet (Lei Federal 12.965/2014) sendo eleito  o  foro  da  Comarca  da  Capital  do  estado  de  Santa  Catarina, para dirimir qualquer controvérsia decorrente deste instrumento.
      </p>
    </v-card-text>

    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-checkbox
        v-model="accept"
        class="mx-3"
        color="primary"
        :rules="[v => !!v || 'Você deve aceitar para continuar!']"
        label="Declaro que li e concordo com os Termos de uso"
        required
      />
      <div class="d-flex justify-space-between pa-2 mb-3">
        <v-btn
          :disabled="!valid"
          :loading="loading"
          block
          color="primary"
          class="button mt-3 mb-4 btn-text"
          style="align-items: center"
          @click="validate"
        >
          Aceitar e Continuar
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import { UpdateTermsOfUseBySellerId } from '@/apollo';

const publicIp = require('public-ip');

export default {
  data() {
    return {
      valid: true,
      accept: false,
      loading: false,
      userIP: null,
    };
  },
  mounted() {
    this.getUserIP();
  },
  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const seller = await this.updateTermsOfUseBySellerId(
          {
            termVersion: 'v1.1',
            sellerIP: this.userIP,
          }, this.$auth.user.sub,
        );
        this.loading = false;
        if (seller.termsOfUse) {
          this.$router.push('/');
        }
      }
    },
    async updateTermsOfUseBySellerId(termsOfUse, sellerId) {
      const res = await this.$apollo.query({
        query: UpdateTermsOfUseBySellerId,
        variables: {
          sellerId,
          termsOfUse,
        },
        fetchPolicy: 'no-cache',
      });
      const seller = res.data.updateTermsOfUseBySellerId;
      this.$store.commit('SET_PERFIL', seller);
      return seller;
    },
    async getUserIP() {
      this.userIP = await publicIp.v4();
    },
  },
};
</script>

<style scoped>
.underline {
  text-decoration: underline;
}

.listStyle {
    list-style-type: lower-alpha;
}
.button {
  border-radius: 7px !important;
  height: 46px;
}
.contact-block-btn-text {
  font-family: 'neue-metana';
  font-style: normal;
  font-weight: normal;
  font-size: 12px !important;
}
</style>
